<template>
  <nav class="cockpit-navigation">
    <ul class="list">
      <li class="item">
        <span class="logo"></span>
      </li>
      <li v-for="l in links" :key="l.routeName" class="item">
        <RouterLink
          class="nav-link"
          :class="{ '-active': currentParentRoute === l.parentRoute }"
          :to="{ name: l.routeName }"
        >
          {{ l.title }}
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const links = [
  {
    routeName: 'OverviewStudents',
    title: t('cockpit.students.linkTitle'),
    parentRoute: 'students',
  },
  {
    routeName: 'OverviewGroups',
    title: t('cockpit.groups.linkTitle'),
    parentRoute: 'groups',
  },
  {
    routeName: 'OverviewMissions',
    title: t('cockpit.missions.linkTitle'),
    parentRoute: 'missions',
  },
  {
    routeName: 'OverviewGames',
    title: t('cockpit.games.linkTitle'),
    parentRoute: 'games',
  },
];

const route = useRoute();

const currentParentRoute = ref<string>(getRouteParent(String(route.path)));

watch(
  () => route.path,
  (newPath) => {
    currentParentRoute.value = getRouteParent(String(newPath));
  },
);

function getRouteParent(path: string) {
  const split = path.split('/');
  const prefixIndex = split.indexOf('cockpit');
  if (prefixIndex >= 0) {
    const parentIdIndex = prefixIndex + 1;
    return split[parentIdIndex] || '';
  }
  return '';
}
</script>

<style scoped lang="scss">
.cockpit-navigation {
  z-index: 10;

  > .list {
    display: flex;
    gap: 1rem;
    height: 100%;
    justify-content: space-between;
    align-items: center;

    > .item {
      > .logo {
        display: inline-block;
        background-image: url('/logo-appolino.svg');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 85px;
        height: 48px;
      }
    }
  }
}
</style>
